<template>
  <!-- <dialogue>

  </dialogue> -->


  <!-- You *may* have to remove this @click handler  @click="close()" -->
  <div class="dialogue">

    <!-- Type 1 : Image -->
    <img class="media image"
      v-if="type === 1"
      :src="media" />

    <!-- Type 2 : Video -->
    <video class="media video"
      v-if="type === 2"
      width="320"
      height="240"
      controls
      autoplay>
       <source :src="media" type="video/mp4">
    </video>

    <!-- Type 3 : Audio -->
    <audio class="media audio"
      v-if="type === 3"
      controls
      autoplay>
      <source :src="media"
      type="audio/mp3">
    </audio>

    <!-- Inject elements -->
    <div class="content">
      <slot />
    </div>

    <button
      type="button"
      class="btn-close"
      @click="close()">
      Close
    </button>

  </div>

</template>

<script>

export default {
  name: 'Dialogue',
  components: {
  },
  props: {
    media:{
      type:String,
      default:''
    },
    type:{
      type:[Number,String],
      default:0
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {
    close () {
      this.$emit('close-dialogue')
    },
  },
  mounted () {

  }
}
</script>

<style lang="scss">

//$pad:20px;
  $pad:12px;
  $margin:48px;
  $spaceForContent:3em;

  .dialogue{

    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:10000;

    animation-name:fade-in;
    animation-duration:195ms;
    //animation-direction: reverse;
    animation-iteration-count: 1;
    animation-fill-mode: both;
    margin:$margin;

    display: flex;
    flex-wrap:nowrap;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding:$pad;
    //border-radius:4px;


    &:before, &:after{
       animation-name:fade-in;
      animation-duration:195ms;
      //animation-direction: reverse;
      animation-iteration-count: 1;
      animation-fill-mode: both;
      animation-delay:0.1s;
    }

    &:before{
      content:'';
      background-color:rgba(255,255,255,0.7);
      //margin:-$margin;
      position: absolute;
      top:0;
      left:0;
      right:0;
      bottom:0;
      z-index:2;
      border-radius:4px;
    }

    &:after{
      content:'';
      background-color:rgba(0,0,0,0.7);
      //margin:-$margin;
      position: absolute;
      top:-$margin;
      left:-$margin;
      right:-$margin;
      bottom:-$margin;
      z-index:1;
    }

    .title, .media, .content, .btn-close{
      position:relative;
       z-index:909;
    }

    // leave some room for the close button
    .title{
      padding: $pad 120px $pad $pad;
      width:100%;
      box-sizing: border-box;
    }

    .media{

      //margin:auto;
      width:100%;
      max-width:100%;
      max-height:calc(100% - #{$margin}*2 - #{$spaceForContent});
      object-fit:contain;

      //overflow: hidden;
      height:auto;
      border-radius:4px;
      @media(max-width:533px){
         max-height:calc(78% - #{$margin}*2 - #{$spaceForContent});
      }

      &.image{
        //width:100%;


      }
      &.video{
        //width:100%;
        //height:auto;
      }
      &.audio{

      }
    }

    // Slot
    .content{
      //padding:$margin;
      //text-transform: uppercase;
      margin-bottom:0;
      p{
        @media(max-width:533px){
          font-size:14px
        }
      }
    }

    .btn-close{
      position:absolute;
      top:$pad ;
      right:$pad;
    }
  }

  @keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade-out{
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>
